import { SUMMARIZE_STATES } from "../../../constants";
import ServerNotRespondingModal from "../../common/ServerNotRespondingModal";
import RtmsErrorModal from "../../organizer/RtmsErrorModal";
import LogManager from "../../utils/LogManager";
import { onSummarize } from "../utils/rtmsSessionUtil";

/**
 * ErrorModals - Handles rendering and logic for RTMS error modals.
 * Shown when RTMS start/stop fails or encounters init/runtime errors.
 */
const ErrorModals = ({
  isServerErrorModalOpen,
  setIsServerErrorModalOpen,
  isRtmsErrorModalOpen,
  setIsRtmsErrorModalOpen,
  rtmsErrorType,
  setRtmsErrorType,
  setSummarizeState,
  setSummarizeClickCount,
  setIsRestarting,
  setIsRtmsStartedByOther,
  setRtmsRequesterName,
  setRtmsStreamId,
  meetingUUID,
  meetingId,
  role,
  appContext,
  sessionStatusIntervalRef,
  sessionStatusTimeoutRef,
  rejectionTimeoutRef,
}) => {
  const handleRtmsErrorCancel = () => {
    setIsRtmsErrorModalOpen(false);
    setRtmsErrorType(null);
    setSummarizeState(SUMMARIZE_STATES.DEFAULT);
    setIsRtmsStartedByOther(false);
    setRtmsRequesterName(null);
    LogManager.info("User cancelled RTMS error modal - reset to original state");
  };

  const handleRtmsErrorRestart = () => {
    setIsRtmsErrorModalOpen(false);
    setRtmsErrorType(null);
    setSummarizeState(SUMMARIZE_STATES.DEFAULT);
    setIsRestarting(true);
    setIsRtmsStartedByOther(false);
    setRtmsRequesterName(null);
    LogManager.info("User clicked restart from RTMS error modal - restarting summarization");
    onSummarize({
      summarizeState: SUMMARIZE_STATES.DEFAULT,
      setSummarizeState,
      setSummarizeClickCount,
      setRtmsRequesterName,
      setRtmsStreamId,
      setRtmsErrorType,
      setIsRtmsErrorModalOpen,
      setIsServerErrorModalOpen,
      meetingUUID,
      meetingId,
      role,
      appContext,
      isRestartAttempt: true,
      sessionStatusIntervalRef,
      sessionStatusTimeoutRef,
      rejectionTimeoutRef,
    });
  };

  return (
    <>
      <ServerNotRespondingModal
        isOpen={isServerErrorModalOpen}
        onClose={() => setIsServerErrorModalOpen(false)}
      />
      {rtmsErrorType && (
        <RtmsErrorModal
          isOpen={isRtmsErrorModalOpen}
          errorType={rtmsErrorType}
          onCancel={handleRtmsErrorCancel}
          onRestart={handleRtmsErrorRestart}
        />
      )}
    </>
  );
};

export default ErrorModals;
